import type { ButtonProps } from "antd";

import { EditOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

export const EditButton = ({ children, ...buttonProps }: ButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button icon={<EditOutlined />} {...buttonProps}>
      {children ?? t("global:edit")}
    </Button>
  );
};
